import { keyframes } from '@emotion/react'
import React from 'react'

import theme from 'theme'

const rotationKeyframes = keyframes({
  '0% ': {
    transform: 'rotate(0deg)'
  },

  '100%': {
    transform: 'rotate(360deg)'
  }
})

interface SpinnerProps {
  size?: number | string
}

const Spinner: React.FC<SpinnerProps> = ({ size = '10em', ...rest }) => (
  <div
    css={{
      position: 'relative',
      margin: '60px auto',
      textIndent: '-9999em',
      borderTop: '1px solid rgba(0, 0, 0, 0.45)',
      borderRight: '1px solid rgba(0, 0, 0, 0.45)',
      borderBottom: '1px solid rgba(0, 0, 0, 0.45)',
      borderLeft: '1px solid #ffffff',
      transform: 'translateZ(0)',
      animation: `${rotationKeyframes} 1.1s infinite linear`,
      borderRadius: theme.borderRadius[2],
      pointerEvents: 'none',
      width: size,
      height: size,
      '&::after': {
        content: "' '",
        borderRadius: theme.borderRadius[2],
        width: size,
        height: size
      }
    }}
    {...rest}
  />
)

export default Spinner
